import { render, staticRenderFns } from "./EventDates.vue?vue&type=template&id=b338e266&scoped=true"
import script from "./EventDates.vue?vue&type=script&lang=js"
export * from "./EventDates.vue?vue&type=script&lang=js"
import style0 from "./EventDates.vue?vue&type=style&index=0&id=b338e266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b338e266",
  null
  
)

export default component.exports